import {
  ClientMonitoring,
  ClientMonitoringStatus,
} from '@interfaces/control/monitoring/responses/client-monitoring.response';
import { MonitoringStatusColumn } from '@interfaces/control/monitoring/responses/monitoring-status.response';

export const MOCK_CLIENTS: ClientMonitoring[] = [
  {
    id: '1',
    name: 'Empresa ABC Ltda',
    status: 'ok' as ClientMonitoringStatus,
    mandateStatus: 'Vigente',
    exposure: { usd: 5000000, eur: 2000000, brl: 10000000 },
    nextEventDays: 45,
    ebitdaMargin: 0.25,
    contingencyStatus: 'Normal',
    bandUsagePercent: 65,
    relativeCost: 0.115,
    pnlSensitivity: 120000,
    owner: 'João Silva',
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-03-20T14:30:00Z',
  },
  {
    id: '2',
    name: 'Tech Solutions S.A.',
    status: 'attention' as ClientMonitoringStatus,
    mandateStatus: 'Vigente',
    exposure: { usd: 3000000, eur: 1500000, brl: 8000000 },
    nextEventDays: 12,
    ebitdaMargin: 0.18,
    contingencyStatus: 'Observação',
    bandUsagePercent: 88,
    relativeCost: 0.128,
    pnlSensitivity: 95000,
    owner: 'Maria Santos',
    createdAt: '2024-02-10T09:00:00Z',
    updatedAt: '2024-03-19T16:45:00Z',
  },
  {
    id: '3',
    name: 'Global Imports Corp',
    status: 'action' as ClientMonitoringStatus,
    mandateStatus: 'Aprovado',
    exposure: { usd: 8000000, eur: 3500000, brl: 15000000 },
    nextEventDays: 7,
    ebitdaMargin: 0.15,
    contingencyStatus: 'Ativo',
    bandUsagePercent: 102,
    relativeCost: 0.145,
    pnlSensitivity: 210000,
    owner: 'Carlos Mendes',
    createdAt: '2024-01-05T11:30:00Z',
    updatedAt: '2024-03-21T10:15:00Z',
  },
  {
    id: '4',
    name: 'Industria Nacional Ltda',
    status: 'event' as ClientMonitoringStatus,
    mandateStatus: 'Expirado',
    exposure: { usd: 12000000, eur: 5000000, brl: 25000000 },
    nextEventDays: 2,
    ebitdaMargin: 0.12,
    contingencyStatus: 'Ativo',
    bandUsagePercent: 115,
    relativeCost: 0.158,
    pnlSensitivity: 350000,
    owner: 'Ana Paula',
    createdAt: '2023-12-20T08:00:00Z',
    updatedAt: '2024-03-21T18:00:00Z',
  },
  {
    id: '5',
    name: 'Serviços Financeiros XYZ',
    status: 'committee' as ClientMonitoringStatus,
    mandateStatus: 'Rascunho',
    exposure: { usd: 15000000, eur: 7000000, brl: 35000000 },
    nextEventDays: 5,
    ebitdaMargin: 0.08,
    contingencyStatus: 'Ativo',
    bandUsagePercent: 125,
    relativeCost: 0.172,
    pnlSensitivity: 420000,
    owner: 'Pedro Costa',
    createdAt: '2024-01-30T13:00:00Z',
    updatedAt: '2024-03-22T09:30:00Z',
  },
  {
    id: '6',
    name: 'Agronegocios Brasil S.A.',
    status: 'ok' as ClientMonitoringStatus,
    mandateStatus: 'Vigente',
    exposure: { usd: 4000000, eur: 1800000, brl: 9000000 },
    nextEventDays: 60,
    ebitdaMargin: 0.22,
    contingencyStatus: 'Normal',
    bandUsagePercent: 58,
    relativeCost: 0.108,
    pnlSensitivity: 85000,
    owner: 'João Silva',
    createdAt: '2024-02-15T14:00:00Z',
    updatedAt: '2024-03-18T11:20:00Z',
  },
  {
    id: '7',
    name: 'Logística Express Ltda',
    status: 'attention' as ClientMonitoringStatus,
    mandateStatus: 'Vigente',
    exposure: { usd: 6000000, eur: 2500000, brl: 12000000 },
    nextEventDays: 15,
    ebitdaMargin: 0.19,
    contingencyStatus: 'Observação',
    bandUsagePercent: 82,
    relativeCost: 0.122,
    pnlSensitivity: 145000,
    owner: 'Maria Santos',
    createdAt: '2024-01-25T10:30:00Z',
    updatedAt: '2024-03-20T15:00:00Z',
  },
  {
    id: '8',
    name: 'Construção e Engenharia S.A.',
    status: 'ok' as ClientMonitoringStatus,
    mandateStatus: 'Vigente',
    exposure: { usd: 7000000, eur: 3000000, brl: 14000000 },
    nextEventDays: 50,
    ebitdaMargin: 0.2,
    contingencyStatus: 'Normal',
    bandUsagePercent: 70,
    relativeCost: 0.118,
    pnlSensitivity: 160000,
    owner: 'Carlos Mendes',
    createdAt: '2024-02-01T09:00:00Z',
    updatedAt: '2024-03-19T12:45:00Z',
  },
];

export const MOCK_STATUS_COLUMNS: MonitoringStatusColumn[] = [
  {
    id: 'ok',
    name: 'Dentro da Banda',
    color: '#10b981',
    clients: [],
  },
  {
    id: 'attention',
    name: 'Atenção',
    color: '#f59e0b',
    clients: [],
  },
  {
    id: 'action',
    name: 'Ação Necessária',
    color: '#fb923c',
    clients: [],
  },
  {
    id: 'event',
    name: 'Evento de Risco',
    color: '#e11d48',
    clients: [],
  },
  {
    id: 'committee',
    name: 'Decisão de Comitê',
    color: '#64748b',
    clients: [],
  },
];
